import {
  PRICE_CALLOUT_DEFAULT_COLOR,
  isRedirectToType,
  isRemainingTimeType,
} from "@circle-react/helpers/paywallCustomizationHelpers";
import {
  ACTION_TYPE,
  COUNTDOWN_TYPE,
  type CountdownProperties,
  type PriceCalloutProperties,
  type ReducedPrice,
  type ReducedPriceProperties,
} from "@circle-react/types/PaywallCustomization";

const REGEX_TO_EXTRACT_NUMBERS = /\D/g;

const serializeCountdownProperties = (
  countdownProperties: Partial<CountdownProperties>,
): CountdownProperties => ({
  enabled: countdownProperties?.enabled ?? false,
  displayed_text: countdownProperties?.displayed_text || "",
  action: isRedirectToType(countdownProperties?.action?.action_type)
    ? {
        action_type: ACTION_TYPE.REDIRECT_TO,
        redirect_to: countdownProperties?.action?.redirect_to,
      }
    : {
        action_type: ACTION_TYPE.DO_NOTHING,
      },
  ...(isRemainingTimeType(countdownProperties?.countdown_type)
    ? {
        countdown_type: COUNTDOWN_TYPE.REMAINING_TIME,
        remaining_time: Number(countdownProperties?.remaining_time),
        remaining_time_interval: "minutes",
      }
    : {
        countdown_type: COUNTDOWN_TYPE.FINISH_AT,
        finish_at: countdownProperties.finish_at
          ? new Date(countdownProperties.finish_at).toISOString()
          : new Date().toISOString(),
      }),
});

const serializePriceCalloutProperties = (
  priceCalloutProperties: Partial<PriceCalloutProperties>,
): PriceCalloutProperties => ({
  callout_color:
    priceCalloutProperties.callout_color ?? PRICE_CALLOUT_DEFAULT_COLOR,
  prices: priceCalloutProperties.prices ?? [],
});

export const transformAmount = (input: string | number | undefined | null) => {
  if (input === undefined || input === null) {
    return 0;
  }

  const stringInput = String(input) || "0";
  return Number(stringInput.replace(REGEX_TO_EXTRACT_NUMBERS, ""));
};

const serializeReducedPriceProperties = (
  reducedPriceProperties: Partial<ReducedPriceProperties>,
): ReducedPriceProperties => ({
  prices: (reducedPriceProperties?.prices || []).map(
    (reducedPrice: ReducedPrice) => ({
      price_id: reducedPrice.price_id,
      amount: transformAmount(reducedPrice.amount),
      upfront_amount: transformAmount(reducedPrice.upfront_amount),
      enabled: reducedPrice.enabled,
    }),
  ),
});

export const paywallCustomizationSerializer = {
  serializeCountdownProperties,
  serializePriceCalloutProperties,
  serializeReducedPriceProperties,
};
